import React, {useEffect, useState} from "react";
import {useTranslation} from "next-i18next";
import {useAppDispatch, useAppSelector} from "../../app/hooks";
import {
  selectIsSubmitting,
  selectRemainingQuestions,
  selectSurveyAnswers,
  setDeadlineMonths
} from "../../redux/survey/macroSurveySlice";
import {HeroHeading2} from "../text";
import {MacroSurveyOptionItemView} from "./MacroSurveyOptionItemView";
import {Button} from "../buttons/Button";
import {LocalizationInfo} from "react-i18next";
import {EventLogger} from "../../utils/eventLogger";
import {AnalyticsEvent} from "../../utils/eventProperties";

export const MacroSurveyDeadlineQuestionView: React.FC<any> = ({  }) => {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()
  const answers = useAppSelector(selectSurveyAnswers)
  const remainingQuestions = useAppSelector(selectRemainingQuestions)
  const isSubmitting = useAppSelector(selectIsSubmitting)

  const getTitle = (deadline: number): LocalizationInfo => {
    switch (deadline) {
      case 1:
        return { key: 'macro_survey:macro_survey_title_month', options: { month: deadline } }
      case 5:
        return { key: 'macro_survey:macro_survey_title_months_plus', options: { month: deadline } }
      default:
        return { key: 'macro_survey:macro_survey_title_months', options: { month: deadline } }
    }
  }

  const options: number[] = [1, 2, 3, 4, 5]
  const [deadlineAnswer, setDeadlineAnswer] = useState<number | undefined>(answers.deadlineMonths)
  const [isValid, setIsValid] = useState<boolean>(false)

  useEffect(() => {
    EventLogger.logEvent(new AnalyticsEvent({ eventName: 'Screen Visited', screenName: 'Nutrition Survey' }, { 'Survey Question': 'Deadline' }))
  }, [])

  useEffect(() => {
    if (deadlineAnswer) {
      setIsValid(true)
    } else {
      setIsValid(false)
    }
  }, [deadlineAnswer])

  return <div className="flex flex-col space-y-8 lg:space-y-10 items-center w-full">
    <HeroHeading2 className="text-center mx-8">{t('macro_survey:macro_survey_header_title_deadline')}</HeroHeading2>

    <div className="w-full">
      {options.map(option => {
        return <div key={option.toString()} className="border-b border-fg-gray-surface last:border-b-0">
          <MacroSurveyOptionItemView
            item={{
              title: getTitle(option),
              id: option.toString(),
              isSelected: deadlineAnswer === option
            }}
            isLoading={false}
            onItemSelected={() => {
              setDeadlineAnswer(option)
            }}
          />
        </div>
      })}
    </div>

    <div className="w-full px-5 md:justify-center md:flex">
      <Button
        isDisabled={!isValid}
        isLoading={isSubmitting}
        size="lg"
        isFullWidth={true}
        onClick={() => {
          deadlineAnswer && dispatch(setDeadlineMonths(deadlineAnswer))
        }}
      >
        {remainingQuestions.length ? t('common:common_title_continue') : t('common:common_title_submit')}
      </Button>
    </div>
  </div>
}